export const getWindow = () => window;
